import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'

import { isMockApi } from '@/shared/env'
export type DispatchDeliveryLine = {
  productName: string
  productionDate: string
  qty: number
}

export type DispatchDeliveryRequest = {
  deliveryId: string
  deviceId: string
  pin: string
  storeName: string
  delmanName: string
  lines: DispatchDeliveryLine[]
}

export type DispatchDeliveryResponse = {
  dispatched_at: string
}

function useMockApi(): boolean {
  return isMockApi
}

function mockDispatch(req: DispatchDeliveryRequest): DispatchDeliveryResponse {
  const hasQty = req.lines.some((line) => line.qty > 0)
  if (!hasQty) {
    throw new Error('Isi minimal 1 produk dengan jumlah lebih dari 0.')
  }

  return {
    dispatched_at: new Date().toISOString(),
  }
}

export async function dispatchDeliveryToDelmanDirect(
  req: DispatchDeliveryRequest,
): Promise<DispatchDeliveryResponse> {
  if (useMockApi()) {
    await new Promise((resolve) => setTimeout(resolve, 500))
    return mockDispatch(req)
  }

  const delivery = encodeURIComponent(req.deliveryId)
  const device = encodeURIComponent(req.deviceId)
  return apiFetch<DispatchDeliveryResponse>(
    `/kitchen/deliveries/${delivery}/dispatch?device_id=${device}`,
    {
      method: 'POST',
      body: JSON.stringify({
        store_name: req.storeName,
        delman_name: req.delmanName,
        lines: req.lines,
        pin: req.pin,
      }),
    },
  )
}

export async function dispatchDeliveryToDelman(
  req: DispatchDeliveryRequest,
): Promise<DispatchDeliveryResponse> {
  return runKitchenSync(
    {
      type: 'dispatch_handover',
      label: `Serah ke delman ${req.storeName}`,
      payload: req,
    },
    () => dispatchDeliveryToDelmanDirect(req),
    () => ({ dispatched_at: new Date().toISOString() }),
  )
}
